import { useTranslation } from "react-i18next";
import { isErrorWithStatus } from "api/helpers";
import { useSnackbar } from "@mindlercare/ui-web";
import { useDeleteAttachment } from "./hooks";
import { GenericMessageModal } from "./GenericMessageModal";

type Props = {
  onClose: () => void;
  open: boolean;
  attachmentKey: string;
  onSuccess: (fileName: string) => void;
};

export const DeleteAttachmentModal = ({
  onClose,
  open,
  attachmentKey,
  onSuccess,
}: Props) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const { mutateAsync: deleteAttachment, isPending: isLoading } =
    useDeleteAttachment();

  const handleDelete = async () => {
    try {
      await deleteAttachment(attachmentKey);

      enqueueSnackbar({
        text: t("DELETE_ATTACHMENT_SUCCESS", { count: 1 }),
        isError: false,
      });

      onSuccess(attachmentKey);

      onClose();
    } catch (error) {
      if (isErrorWithStatus(error, 404)) {
        enqueueSnackbar({
          text: t("ATTACHMENT_NOT_FOUND"),
          isError: true,
        });
        return;
      }

      enqueueSnackbar({
        text: t("SOMETHING_WENT_WRONG"),
        isError: true,
      });
    }
  };

  return (
    <GenericMessageModal
      onClose={onClose}
      open={open}
      title={t("DELETE_ATTACHMENT_PROMPT")}
      onConfirm={handleDelete}
      isLoading={isLoading}
    />
  );
};
